<template>
  <div
    class="d-flex align-items-center"
    :class="{'mb-3' : indent}"
  >
    <span
      class="d-block font-weight-bold font-size-20"
      :class="{'mr-1' : tooltipText}"
    >
      {{ title }}
    </span>
    <a-tooltip v-if="tooltipText" placement="topLeft" arrow-point-at-center>
      <template slot="title">
        <span>{{ tooltipText }}</span>
      </template>
      <a-icon class="d-flex ml-2" type="info-circle" />
    </a-tooltip>
  </div>

</template>

<script>

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    tooltipText: {
      type: String,
      default: '',
    },
    indent: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
